"use client";

import {
  ConversionCard,
  GooglePositionCard,
  LostClientsCard,
  RevenueLossCard,
} from "@/components/sections/dashboard-cards";
import { DashboardAnimatedCard } from "@/components/sections/dashboard-animated-card";
import {
  HERO_ENTRANCE_PERSPECTIVE,
  HERO_ENTRANCE_PERSPECTIVE_ORIGIN,
  type HeroEntranceConfig,
} from "@/lib/hero-entrance-motion";

const CARD_COLUMN_BAND =
  "absolute top-[8%] bottom-[18%] flex w-[168px] flex-col justify-between xl:top-[10%] xl:bottom-[20%] xl:w-[200px]";

const CARD_CONFIGS = {
  revenue: { rotateZ: -6, originX: 340, originY: 200, originZ: -280 },
  conversion: { rotateZ: 4, originX: 280, originY: 240, originZ: -320 },
  google: { rotateZ: 6, originX: -340, originY: 200, originZ: -280 },
  lost: { rotateZ: -4, originX: -280, originY: 240, originZ: -320 },
} as const satisfies Record<string, HeroEntranceConfig>;

export function HeroDashboardCards() {
  return (
    <div
      className="pointer-events-none absolute inset-0 hidden md:block"
      aria-hidden
      style={{ perspective: HERO_ENTRANCE_PERSPECTIVE, perspectiveOrigin: HERO_ENTRANCE_PERSPECTIVE_ORIGIN }}
    >
      <div
        className={`${CARD_COLUMN_BAND} left-[1%] md:left-[2%] xl:left-[calc(50%-27rem)] xl:-translate-x-full`}
        style={{ transformStyle: "preserve-3d" }}
      >
        <DashboardAnimatedCard config={CARD_CONFIGS.revenue}>
          <RevenueLossCard />
        </DashboardAnimatedCard>
        <DashboardAnimatedCard
          config={CARD_CONFIGS.conversion}
          className="hidden xl:ml-6 xl:block xl:self-start"
        >
          <ConversionCard />
        </DashboardAnimatedCard>
      </div>

      <div
        className={`${CARD_COLUMN_BAND} right-[1%] md:right-[2%] xl:left-[calc(50%+27rem)] xl:right-auto`}
        style={{ transformStyle: "preserve-3d" }}
      >
        <DashboardAnimatedCard config={CARD_CONFIGS.google}>
          <GooglePositionCard />
        </DashboardAnimatedCard>
        <DashboardAnimatedCard
          config={CARD_CONFIGS.lost}
          className="hidden xl:mr-6 xl:block xl:self-end"
        >
          <LostClientsCard />
        </DashboardAnimatedCard>
      </div>
    </div>
  );
}
